import React, { Component } from "react";
import axios from "axios";

import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";

import { API_CONSTANTS } from "../../shared/constants/api.constants";
import Header from "../layout/Header";

import {
  sendFlashMessage,
  clearcurrentFlashMessage,
} from "../../actions/flashMessage";
import Flashmessages from "../flashMessagesComp/flashMessages";

import Loader from "../common/GlobalLoader";

class Sectors extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      sectors: null,
      sectorObj: {
        id: "",
        name: "",
        description: "",
        externalId: ""
      }
    }

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    this.loadSectors()
  }

  onChange(e) {
    const state = this.state.sectorObj;
    state[e.target.name] = e.target.value;
    this.setState({ sectorObj: state });
  }

  loadSectors() {
    this.setState({ loading: true })
    axios
      .get(`${API_CONSTANTS.COUNCIL.GET_WCEA_SECTORS}`)
      .then((res) => {
        this.setState({
          sectors: res.data,
          loading: false
        })
      })
      .catch((err) => {
        this.setState({ loading: false })
        this.props.sendFlashMessage(
          "Something went wrong !!",
          "alert-danger"
        )
        setTimeout(() => {
          this.props.clearcurrentFlashMessage();
        }, 2000)
      })
  }

  onSubmit(e) {
    e.preventDefault();
    e.stopPropagation()

    if (!this.validateForm()) {
      return;
    }

    this.setState({ loading: true });

    let sectorObj = this.state.sectorObj

    let data = {
      name: sectorObj.name,
      description: sectorObj.description,
      externalId: sectorObj.externalId
    }

    if (sectorObj['id']) data['id'] = sectorObj.id

    if (sectorObj.id) { // EDIT
      axios
        .put(
          `${API_CONSTANTS.COUNCIL.UPDATE_WCEA_SECTORS(sectorObj.id)}`,
          data
        )
        .then((res) => {
          this.props.sendFlashMessage(
            "Sector updated successfully !!",
            "alert-success"
          );
          setTimeout(() => {
            this.props.clearcurrentFlashMessage();
          }, 2000);
          this.setState({ loading: false })
          this.resetForm()
          this.loadSectors()
        })
        .catch((err) => {
          this.setState({ loading: false });
          console.log("error is : " + err);
          this.props.sendFlashMessage("Something went wrong !!", "alert-danger");
          setTimeout(() => {
            this.props.clearcurrentFlashMessage();
          }, 2000);
        })
    } else { // NEW
      axios
        .post(
          `${API_CONSTANTS.COUNCIL.ADD_WCEA_SECTORS}`,
          data
        )
        .then((res) => {
          this.props.sendFlashMessage(
            "Sector created successfully !!",
            "alert-success"
          );
          setTimeout(() => {
            this.props.clearcurrentFlashMessage();
          }, 2000);
          this.setState({ loading: false })
          this.resetForm()
          this.loadSectors()
        })
        .catch((err) => {
          this.setState({ loading: false });
          console.log("error is : " + err);
          this.props.sendFlashMessage("Something went wrong !!", "alert-danger");
          setTimeout(() => {
            this.props.clearcurrentFlashMessage();
          }, 2000);
        })
    }
  }

  validateForm() {
    if (!this.state.sectorObj.name) {
      this.props.sendFlashMessage(
        "Please enter Sector name",
        "alert-danger"
      )
      setTimeout(() => {
        this.props.clearcurrentFlashMessage()
      }, 2000)
      return false
    }
    return true
  }

  resetForm() {
    this.setState({
      sectorObj: {
        id: "",
        name: "",
        description: "",
        externalId: ""
      }
    })
  }

  editSector = (e, sectorId) => {
    e.preventDefault();
    let sector = this.state.sectors.find((sector) => sector.id == sectorId)

    if (sector && sector.id) {
      let data = {
        id: sector.id,
        name: sector.name || "",
        description: sector.description || "",
        externalId: sector.externalId || ""
      }

      this.setState({ sectorObj: data })
    }
  }

  deleteSector = (e, sectorId) => {
    e.preventDefault();
    this.setState({ loading: true })

    axios
      .delete(`${API_CONSTANTS.COUNCIL.DELETE_WCEA_SECTORS(sectorId)}`)
      .then((res) => {
        this.props.sendFlashMessage(
          "Sector deleted successfully !!",
          "alert-success"
        );
        setTimeout(() => {
          this.props.clearcurrentFlashMessage();
        }, 2000);
        this.setState({ loading: false })
        this.loadSectors()
      })
      .catch((err) => {
        this.setState({ loading: false });
        console.log("error is : " + err);
        this.props.sendFlashMessage(
          "Something went wrong !!",
          "alert-danger"
        );
        setTimeout(() => {
          this.props.clearcurrentFlashMessage();
        }, 2000);
      })
  };

  render() {
    const { sectorObj, sectors } = this.state;

    return (
      <section class="wrapper">
        <Header />
        <section class="">
          <Flashmessages />
          <div class="container-fluid">
            <div class="spacetb25">
              <div class="row">
                <div class="col-xl-8 offset-xl-2">
                  <form onSubmit={this.onSubmit} encType="multipart/form-data">
                    <div class="card card__custom">
                      <div class="card-header">
                        <h5 class="card-title">*= Required Fields</h5>
                      </div>
                      <div class="card-body">
                        <div class="row">
                          <div class="col-sm-12">
                            <div class={`form-group textbox__label`}>
                              <label>Name *</label>
                              <input
                                type="text"
                                class="form-control"
                                onChange={this.onChange}
                                id="name"
                                placeholder="Enter Sector name"
                                name="name"
                                value={sectorObj.name || ""}
                                required
                              />
                            </div>
                          </div>
                          <div class="col-sm-12">
                            <div class={`form-group textbox__label`} >
                              <label>Description</label>
                              <textarea
                                className="form-control"
                                onChange={this.onChange}
                                id="description"
                                placeholder="Enter Description"
                                name="description"
                                value={sectorObj.description || ""}
                                rows="4"
                              />
                            </div>
                          </div>
                          <div class="col-sm-12">
                            <div class={`form-group textbox__label`} >
                              <label>External ID</label>
                              <input
                                type="text"
                                className="form-control"
                                onChange={this.onChange}
                                id="externalId"
                                placeholder="Enter External ID"
                                name="externalId"
                                value={sectorObj.externalId || ""}
                              />
                            </div>
                          </div>
                          <div class="col-sm-12">
                            <div className="text-center">
                              <button type="Submit" class="btn btn-secondary">Submit</button>
                            </div>
                          </div>
                        </div>

                        <div className={`show-advertisement pd-t-20 mg-t-20`}>                                        
                          <h5 class="mg-b-20 text-center"><strong>Sectors</strong></h5>  
                          <div class="table-box">
                            <div class="table-responsive">
                              <table class="table" style={{ minWidth: "900px" }}>
                                <thead>
                                  <tr>
                                    <th style={{ width: "20%" }}>Name</th>
                                    <th style={{ width: "40%" }}>Description</th>
                                    <th style={{ width: "15%" }}>External ID</th>
                                    <th style={{ width: "15%" }}>Created At</th>
                                    <th class="text-center" style={{ width: "5%" }}>Edit</th>
                                    <th class="text-center" style={{ width: "5%" }}>Delete</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {
                                    (sectors || []).map((sector) => (
                                      <tr key={sector.id}>                                                
                                        <td>{ sector.name }</td>
                                        <td>{ sector.description || "-" }</td>
                                        <td>{ sector.externalId || "-" }</td>
                                        <td>{ sector.createdAt ? new Date(sector.createdAt).toLocaleDateString() : "-" }</td>
                                        <td class="text-center">
                                          <a href="javascript:void(0)" class="btn btn-primary text-edit" onClick={(e) => this.editSector(e, sector.id)}>
                                            <span class="icon-edit"></span>
                                          </a>
                                        </td>
                                        <td class="text-center">
                                          <a href="javascript:void(0)" class="btn btn-primary text-edit" onClick={(e) => this.deleteSector(e, sector.id)}>
                                            <span class="icon-cross clos-icon"></span>
                                          </a>
                                        </td>
                                      </tr>      
                                    ))
                                  }
                                </tbody>
                              </table>
                            </div>
                          </div>  
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Loader loadStatus={this.state.loading} />
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
})

export default connect(mapStateToProps, {
  sendFlashMessage,
  clearcurrentFlashMessage,
})(withRouter(Sectors))

